import apiClient from '../api-client';

export const getRecommendedPlaces = () => apiClient.get('place/recommended').then(res => res.data);
export const getPlace = (slug) => apiClient.get('place/' + slug).then(res => res.data);
